<template>
    <div>
        <el-row type="flex" class="menu-row">
            <el-col :span="24">
                <div class="main-menu">
                    <el-scrollbar wrap-class="scrollbar-wrapper">

                        <el-menu :default-active="activeMenu">
                            <sub-item v-for="route in routes" :key="route.path" :item="route" :base-path="route.path" />
                        </el-menu>

                    </el-scrollbar>
                </div>
            </el-col>
        </el-row>

    </div>
</template>

<script>
import page from "./index.js";
export default page;
</script>

<style lang="scss" scoped>
@import "./index.css";
</style>


// WEBPACK FOOTER //
// src/layout/master/components/sidebar/index.vue